module.exports = __webpack_public_path__ + "assets/yun.f25ff345.svg";